<script lang="ts">
	import logo from '$lib/assets/images/logo.svg?url';
</script>

<section id="hero" class="flex min-h-screen items-center justify-center">
	<div class="mt-10 mb-20 flex h-full max-w-140 flex-col items-center justify-center">
		<img class="h-15 w-28.5 md:h-25 md:w-55" src={logo} alt="Mifroma's logo" />
		<h1 class="mt-10 text-center text-[2.3rem] leading-none uppercase md:text-[4rem]">
			Choose your&nbsp;Master Cheesemaker
		</h1>
		<p class="mt-5 mb-8 text-center leading-[130%] tracking-percent md:text-xl">
			Choose the Master Cheesemaker who matches your taste and curiosity. They’ll be your personal
			guide bringing you closer to our craft through stories, expertise, and exclusive moments from
			the heart of Mifroma.
		</p>
		<div class="flex max-w-screen flex-wrap justify-center gap-4.5">
			<a
				class="rounded-sm bg-theme-brown px-5.5 py-4.5 font-bold text-black uppercase"
				href="#masters">DISCOVER our masters</a
			>
			<a class="rounded-sm bg-theme-brown px-5.5 py-4.5 font-bold text-black uppercase" href="#quiz"
				>TAKE THE QUIZ</a
			>
		</div>
	</div>
</section>
